import SearchHelper from '../../helpers/SearchHelper'
import Utils from '../../utilities/Utils'
import request, { AccountantApiError } from './request'

export type TransactionExportType = 'xlsx' | 'csv'

export default class TransactionsController {
  static getTransactions(workspaceId: string, params: object) {
    return request(`/api/workspaces/${workspaceId}/transactions?${SearchHelper.getQueryString(params)}`)
  }

  static async export(workspaceId: string, exportType: TransactionExportType, year: number, quarter: number): Promise<{ blob: Blob, filename: string }> {
    const res = await fetch(`/api/workspaces/${workspaceId}/transactions/export?${Utils.encodeQueryData({ export_type: exportType, year, quarter })}`, {
      credentials: 'same-origin',
    })
    if (!res.ok) throw new AccountantApiError(res.status)

    const disposition = res.headers.get('Content-Disposition') || ''
    const match = disposition.match(/filename="([^"]+)"/)

    return { blob: await res.blob(), filename: match ? match[1] : `transactions.${exportType}` }
  }
}
